// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCanvasVersionsResult = arrayOf(
  objectOf({
    version_id: string,
    created_at: string,
    developer_name: string,
  })
);
